// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-m_fz","advertDetailContactItem__link":"c-m_fA"};